<template>
    <v-container fluid>
    
        <v-card flat>
            <v-toolbar>
                <v-icon></v-icon>
                <v-toolbar-title class="font-weight-light"> 
                    <v-row>
                        <v-col >
                            <div>&nbsp;Cierre de Caja </div>
                        </v-col>
                    </v-row>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>                    
            </v-toolbar>

            <v-card-text>
                <v-container fluid>                    
                    <v-row>
                        <v-col cols="2">
                            Caja
                        </v-col>
                        <v-col>
                            {{caja.descripcion}}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            Fecha
                        </v-col>
                        <v-col>
                            {{this.$moment(caja.abiertaEl).format('DD-MM-YYYY')}}
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field v-model="saldoCierre" label="Resultado del Arqueo" type="number" prefix="$"></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row>                        
                        <v-textarea
                            v-model="comentarios"
                            class="mx-2"
                            label="Comentarios Adicionales"
                            prepend-icon="comment"
                            clearable
                            auto-grow
                        ></v-textarea>
                    </v-row>
                    
                </v-container>
            </v-card-text>

            <v-divider></v-divider>  
            <v-card-actions>
                <v-btn color="blue darken-1" text @click.stop="hide(false)">Cerrar</v-btn>
                <v-spacer></v-spacer>                
                
                <v-btn v-if="!forzar" color="blue darken-1" text @click.stop="save(false)" >Confirmar Cierre</v-btn>
                <v-btn v-if="forzar" color="red darken-1" text @click.stop="save(true)" >Confirmar Cierre con Diferencia</v-btn>
            </v-card-actions>
        </v-card>
        
        <template v-if="$store.state.debugModeOn">
            Debug Info: <p></p>
            
            Model: {{gestion}}  <p></p>                            
        </template>
    </v-container>
</template>


<script>

import Vue from 'vue'
import { http } from '@/axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data: () => ({        
        saving: false,
        loadingCajas: false,
        saldoCierre: null,
        comentarios: '',
        forzar: false,
        }
    ),
    props:{
        caja: { type: Object, default: {} },        
        accionCompleta:{ type: Function },
        isSubTask: { type: Boolean, default: false },
        visible: { type: Boolean, default: false },
    },
    async created(){  
        
    },
    computed: {
        ...mapGetters(['getActionFromLink','user']),
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
    },
    watch:{
        visible: function(){
            if(this.visible){
            }
        },        
    },
    methods:{
    ...mapMutations(["setActiveTask", "setActiveSubTask", "hideActiveTask", "hideActiveSubTask", 
                        "alertClear", "alertSuccess", "alertWarning", "alertError"]),
    async save(forzado){
        
        if(!this.validarDatos()) return;

        var params = {
            cajaId: this.caja.id,
            saldoArqueo: this.saldoCierre,
            forzar: forzado,
            motivo: this.comentarios
        };

        this.saving = true
        try {
            var result = await  http.post('cajas/cerrarcaja', JSON.stringify( params )); 
            
            if(result.seCambio){
                this.alertSuccess('La Caja ha sido cerrada')
                this.emitAccionCompleta();

                await this.listadosCaja();
                await this.hide(true);
            }
            else{
                this.alertWarning(result.motivo)
                this.forzar = true;
            }

        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.saving = false
    },
    validarDatos(){
        if(!this.saldoCierre)
        {
            this.alertWarning('Por favor, ingrese el resultado del arqueo para continuar con el cierre.');
            return false;
        }

        return true;
    },
    async listadosCaja (){
        var caja = this.caja;

        var params = {
            width:500,
            temporary: true,
            caja: caja,
            isSubTask: true
        };

        await this.setActiveSubTask({task:'app-listados-caja', props: params});
    },
    async hide(cerrarRelacionados){
        //esto lo hago para que no se buguee cuando lo abro como subtask o task
        if(this.isSubTask)
            await this.hideActiveSubTask();
        else
            await this.hideActiveTask(cerrarRelacionados);
    },
    emitAccionCompleta () {        
        if(this.accionCompleta)
            this.accionCompleta();

      this.$emit('accion-completa')
    }
  }
}
</script>
